import React, { Fragment, useState, useEffect } from "react"
import { CSSTransition } from "react-transition-group"
import queryString from "query-string"
import { ReviewView } from "./components/ReviewView"
import HowItWorksView from "./components/HowItWorksView"
import ThankYouView from "./components/ThankYouView"
import StatusView from "./components/StatusView"
import UploadView from "./components/UploadView"
import { SetReminderWrapper } from "./components/SetReminderWrapper"
import UploadedImageList from "./components/UploadedImageList"
import { createAttachment, getSubmissionStatus, removeAttachment, submitReceiptSubmission, requestEmailReminder, postFormWithProgress, PostFormWithProgressClass } from "services/receipt"
import { scrollToTopOfCurrentStep } from "services/break"
import analytics from "global/AnalyticsData"
import { sleep } from "util/misc"
import "./ReceiptVerificationStep.scss"
import "./ReceiptVerificationStepMobile.scss"




const ReceiptVerificationStep = ({ breakId, step, service, onEngage = function () {}, onAwardPoints = function () {}, onChangeBackground = function () {}, skipButton, nextStepButton, onStepSkip, themeColors, handleInstantWinEvent=null }) => {
    const [position, setPosition] = useState(0)
  const [uploadErrors, setUploadErrors] = useState(null)
  const [nonFieldErrors, setNonFieldErrors] = useState([])
  const [uploadProgress, setUploadProgress] = useState(null)  // holds an object shaped like {progress:[0-100], filename:"name" }
  const [uploadedImages, setUploadedImages] = useState([])
  //populated with user submission if already submitted; if null, then they're doing it for the first time.
  const [userSubmission, setUserSubmission] = useState(null)
  //A bit dirty, but this shows us the step is loaded.
  const [rewardSelected, setRewardSelected] = useState(null)

  const [reminderFormSent, setReminderFormSent] = useState(false)
  const [receiptSubmissionId, setReceiptSubmissionId] = useState("") // something weird on API side. This has to initially be '', not null or undefined

  const [loaded, setLoaded] = useState(false) //true after we check the status of the receipt submission
  const [previousSubmissionStatus, setPreviousSubmissionStatus] = useState(null)

  const tryToGetToken = (tokenName="token") => {
    try {
      let qs = queryString.parse(window.location.search)
      if (qs[tokenName]) {
        return qs[tokenName]
      } else {
        return null
      }
    } catch (e) {
      return null
    }
  }

  useEffect(() => {

        if (handleInstantWinEvent && previousSubmissionStatus) {
            handleInstantWinEvent({eventName: `receipt-submission-status-${previousSubmissionStatus.status}`.toLowerCase(), context: {receiptStatusResult: previousSubmissionStatus.fullResponse, stepId: step.id}})
        }

    }, [previousSubmissionStatus, handleInstantWinEvent])


  const attemptToRetrievePendingSubmission = async token => {
    try {
      let theToken = await tryToGetToken("token")
      console.log(theToken)
      if (theToken !== null) {
        const statusResult = await getSubmissionStatus({breakId: breakId, stepId: step.id, token: theToken, receiptId: stepData.id})
        const {status, rewardId, email, breakId, firstName, lastName, address1, address2, city, state, postalCode, phoneNumber } = statusResult
        if (typeof status === "string") {

          const chosenReward = step.receiptVerificationCampaign.rewards.find((reward) => {
            return reward.id === rewardId
          })

          await setPreviousSubmissionStatus({status:status, reward: chosenReward, fullResponse: statusResult})
          onEngage()

          await setLoaded(true) // fire this to load up the ui
          
        }
      }
    } catch (e) {
      console.log(e)
    }
    await setLoaded(true)
  }

  const returningFromReminder = async token => {
    try {
      let theToken = await tryToGetToken()
      if (theToken !== null) {

      }
    } catch (e) {
      console.log(e)
    }
    await setLoaded(true)
  }

  //check to see if user is coming from email.
  useEffect(() => {
    attemptToRetrievePendingSubmission()
  }, [])

  const animationDuration = 400
  const stepData = step.receiptVerificationCampaign

  //First image upload triggers next view.
  const handleImagesUploaded = attemptNumber => {
    console.log("uploaded", attemptNumber)
    if (position === 0 && attemptNumber === 0) {
      setPosition(1)
  
    }
  }

  // clicking "not yet"
  const handleNotYetClicked = () => {
    scrollToTopOfCurrentStep(step.id)
    setPosition(4)
  }

  //clicking "next" button triggers next view.
  const handleUploadNext = () => {
    let currentPosition = position
    scrollToTopOfCurrentStep(step.id)
    setPosition(currentPosition + 1)
  }
 
 

  const handleUploadProgress = (p) => {
  
    // race condition. This bombs often b/c uploadProgress is null. setUploadProgress hasn't completed before this is called again?
    try {
      let tmp = JSON.parse(JSON.stringify(uploadProgress))
      tmp.progress = p
      setUploadProgress(tmp)  
    } catch (e) {
      // console.log(e)
      setUploadProgress({progress: p})  
    }

  }

  const handleSingleFileUpload = async file => {
    console.log(`handleImageUpload`, file)
    try {
      
      await setUploadProgress({filename: file.name, progress: 0})   // await needed?
      
      const payload = new FormData()
      payload.append("file", file)
      payload.append("breakId", breakId)
      payload.append("stepId", step.id)
      payload.append("receiptId", step.receiptVerificationCampaign.id)
      payload.append("receiptSubmissionId", receiptSubmissionId)    
      
      postFormWithProgress('/receiptVerification/upload', payload, handleUploadProgress)
      .then( async (result) => {
          result = JSON.parse(result)
          console.log(`handleDone`, result)

          setReceiptSubmissionId(result.receiptSubmissionId)
          let tempUploadedImages = uploadedImages
          await tempUploadedImages.push({ file: file, info: result })
          await setUploadedImages(tempUploadedImages)

          await setUploadProgress(null) // remove our in-progress item, it will be added to uploadedImages

      }).catch((error) => {
          console.warn(error)
      })
    } catch (e) {
      setUploadErrors(`Error uploading receipt. Please try again. ${e}`)
    }
  }

  const handleSingleFileUpload2 = async file => {
    console.log(`handleImageUpload`, file)
   
      
      await setUploadProgress({filename: file.name, progress: 0})   // await needed?
      
      const payload = new FormData()
      payload.append("file", file)
      payload.append("breakId", breakId)
      payload.append("stepId", step.id)
      payload.append("receiptId", step.receiptVerificationCampaign.id)
      payload.append("receiptSubmissionId", receiptSubmissionId)    
      
    const onProgress = (p) => {
      setUploadProgress({filename: file.name, progress: p})

    }
    const onError = (e) => {
      setUploadErrors(e)
    }
    const onSuccess = async(result) => {
        result = JSON.parse(result)
      console.log("upload success", result)
      
      console.log(`handleDone`, result)

      setReceiptSubmissionId(result.receiptSubmissionId)
      let tempUploadedImages = uploadedImages
      await tempUploadedImages.push({ file: file, info: result })
      await setUploadedImages(tempUploadedImages)

      await setUploadProgress(null) // remove our in-progress item, it will be added to uploadedImages
    }
      let thisUpload = new PostFormWithProgressClass(payload,  onProgress, onError, onSuccess)
     
      
    
  }

  const handleImageUpload = async files => {
    console.log(`handleImageUpload`)

    if (files.length > 0) {
      if (position === 0) {
        scrollToTopOfCurrentStep(step.id)
        setPosition(1)
      }
      
    }

    // await files.forEach(async (file) => {
    for await (let file of files) {
      await handleSingleFileUpload(file)
    }
    
  }

  const handleRemoveImage = async (id) => {
    try {
    if (id) {
      const response = await removeAttachment(breakId, step.id, step.receiptVerificationCampaign.id, receiptSubmissionId, id)
    
      if (response.status === 200) {
       // console.warn(`image removed, uploadedImages.filter not implemented`)
   
        let imagesWorkingArray = uploadedImages
        let filtered = imagesWorkingArray.filter(image => image.info.id !== id)
        setUploadedImages(filtered)
      } else {
        let result = await response.json()
        console.warn(`upload result`, result)
  
      }
  
    } else {
      throw new Error(`no attachment id passed`)
    }
  }
    catch(e) {
      setUploadErrors(e)
    }

  }



  const editMySubmission = () => {
    scrollToTopOfCurrentStep(step.id)
    setPosition(position - 1)
  }


  const handleTheFormSubmission = async (values) => {

    analytics.stepEvent("step_interaction_receipt_submit", step)
    console.log(`handleFormSubmission`, values)
    //Need to persist selected reward in state because it changes "thank you" outcome.
    const rewardSelectedLocal = stepData.rewards.find(reward => reward.id === values.rewardId)
    const submissionObject = {
      breakId: breakId,
      stepId: step.id,
      receiptId: step.receiptVerificationCampaign.id,
      receiptSubmissionId: receiptSubmissionId,
      ...values
    }
    const response = await submitReceiptSubmission(submissionObject)
    if (response.status == 200) {
      setRewardSelected(rewardSelectedLocal)
      scrollToTopOfCurrentStep(step.id)
      setPosition(position + 1)
      onEngage()
      onAwardPoints()  
    } else {
      let result = await response.json()
    //   alert(result.message)
      
      setNonFieldErrors([result.message])
    }
  }


  //Review form parses validation, if it passes, this function runs.

  //this is a wrapper function for the original function due to instant win.
  const handleFormSubmission = async values => {
    handleTheFormSubmission(values)
  }

  const handleRequestReminder = async email => {
    analytics.stepEvent("step_interaction_receipt_reminder_submit", step)
    if (window !== undefined) {
      try {
        const link = window.location.href
        const resp = await requestEmailReminder(breakId, step.id, step.receiptVerificationCampaign.id, email, link)
        resp.status === 200 ? setReminderFormSent(true) : setReminderFormSent(false)

        setReminderFormSent(true)
        onEngage()
        onAwardPoints()
      } catch (e) {
        console.log(`issue submitting reminder form: ${e}`)
      }
    }
  }
  const handleStatusRetrieved = async (status) => {
   
    if (status === "approved") {
      //This ask is weird so it deserves a weird solution
      analytics.stepEvent("step_interaction_receipt_approval", step)
      
    }

  }
  const hasUploadedImages = uploadedImages.length > 0
  const stepViewArray = [
    <HowItWorksView themeColors={themeColors} handleImageUpload={handleImageUpload} headerImage={stepData.headerImage} headline={stepData.headline} introCopy={stepData.introCopy} userPathHeadline={stepData.userPathHeadline} instructions={stepData.instructions} onNotYetClicked={handleNotYetClicked} />,
    <UploadView canContinue={hasUploadedImages} setUploadErrors={setUploadErrors} onUploadNext={handleUploadNext} handleImageUpload={handleImageUpload} headline={stepData.uploadHeadline} introCopy={stepData.uploadIntroCopy} uploadInProgress={uploadProgress}>
      <UploadedImageList uploadErrors={uploadErrors}  uploadedImages={uploadedImages} handleRemoveImage={handleRemoveImage} uploadProgress={uploadProgress}/>
    </UploadView>,
    <ReviewView headerTitle={stepData.reviewHeader} headerSubtitle={stepData.reviewCopy} reviewListHeader={stepData.reviewListHeader} instructions={stepData.detailedInstructions} rewardOptions={stepData.rewards} onFormSubmission={handleFormSubmission} editMySubmission={editMySubmission} nonFieldErrors={nonFieldErrors} >
          <UploadedImageList uploadErrors={uploadErrors} uploadedImages={uploadedImages} handleRemoveImage={handleRemoveImage} uploadProgress={uploadProgress} />
    </ReviewView>,
    <>{rewardSelected && <ThankYouView headline={rewardSelected.thankyouHeader} bodyCopy={rewardSelected.thankyouBody} image={rewardSelected.rewardImage}  /> } </>,
    <SetReminderWrapper 
        setPosition={setPosition} requestReminder={handleRequestReminder} reminderFormSent={reminderFormSent} 
          reminderHeader={stepData.reminderHeader}
          reminderCopy={stepData.reminderCopy}
          reminderThanksHeader={stepData.reminderThanksHeader}
          reminderThanksCopy={stepData.reminderThanksCopy}
          headerImage={stepData.headerImage}
          instructionsHeader={stepData.reminderThanksInstructionsHeader}
          instructions={stepData.reminderInstructions}
        />,
  ]

  return (
    <>
      <section className="receipt-verification-step">
        {loaded === true && (
          <>
            <div className="step-content with-shadow">
              <div className="step-view-container will-fade-transition-container">
                {previousSubmissionStatus === null ? (
                  <>
                    {stepViewArray.map((component, i) => {
                      return (
                        <CSSTransition key={i} in={position === i} timeout={animationDuration} className={`will-fade-transition ${position === i ? "is-active" : "is-inactive"}`}>
                          <div> 
                            {position === i && (
                            <Fragment key={`receipt-transition-view-item-${i}`}>{component}</Fragment>
                            )}
                          </div>
                        </CSSTransition>
                      )
                    })}
                  </>
                ) : (
                  <StatusView status={previousSubmissionStatus.status} reward={previousSubmissionStatus.reward} onStatusRetrieved={handleStatusRetrieved} />
                )}
              </div>
                      {stepData.stepTerms && (
                <div className={`legal-text-container`}>
                  <p dangerouslySetInnerHTML={{ __html: stepData.stepTerms }} />
                </div>
              )}

              {skipButton}
              {nextStepButton}
            </div>
          </>
        )}
      </section>
    </>
  )
}

export default ReceiptVerificationStep
